<template>
  <Calendar />
</template>

<script>
import Calendar from "@/components/calendar/Calendar";

export default {
  components: { Calendar },
};
</script>

<style></style>
